  <ng-container #refreshedUi>
    <div id="advanced-filters" class="bg-white">
      
      <!-- Selected chips and clear all row -->
      <div *ngIf="getVal().length > 0" class="flex items-center gap-2 px-12 py-3 m-auto">
        <div class="whitespace-nowrap">Filters Selected:</div>
        <div id="selected-filter-list" class="flex items-center gap-2">
          <div
            id="selected-filters"
            *ngFor="let filter of getVal()" 
            class="w-fit text-neptune-default border border-solid rounded-[16px] gap-2 px-3 py-1 border-neptune-border-subtle"
          >
            <div class="flex items-center gap-2" [id]="'selected-filter-option-' + filter">
              <div id="chip-text">{{ filter }}</div>
              <img
                *ngIf="true"
                src="assets/shared-icons/neptune-icon-black-close.svg"
                class="cursor-pointer h-[16px]"
                (click)="removeFilter(filter)"
                alt="cancel icon"
              />
            </div>
          </div>
          <div *ngIf="this.flattenFilterOptions().length > this.selectedFilterDisplayLimit" class="relative">
            <div
              id="show-more"
              class="w-fit border rounded-[16px] px-3 py-1 bg-neptune-color-primary-600 text-white cursor-pointer"
              (click)="toggleShowAllFiltersModal()"
              >+{{ this.flattenFilterOptions().length - this.selectedFilterDisplayLimit }} more
            </div>
            <div
              *ngIf="showAllSelectedFiltersModal"
              id="show-all-filters-modal"
              class="absolute top-full max-h-[400px] w-[230px] px-3 py-3 overflow-y-scroll left-0 z-50 mt-1 bg-white border border-solid border-[1px] border-neptune-border-subtle shadow-sm"
            >
              <div class="flex items-center justify-between px-4 py-2 mb-3 text-black border-0 border-b-[2px] border-solid border-neptune-color-primary-100">
                <div>
                  {{ this.flattenFilterOptions().length - this.selectedFilterDisplayLimit }} more selected
                </div>
                <img
                  *ngIf="true"
                  src="assets/shared-icons/neptune-icon-black-close.svg"
                  class="cursor-pointer h-[16px]"
                  (click)="toggleShowAllFiltersModal()"
                  alt="cancel icon"
                />
              </div>
              <div>
                <div *ngFor="let filter of filterOptions" class="mb-3">
                  <div class="border border-solid border-neptune-neutral flex items-center justify-between px-4 py-2"
                      [ngClass]="this.selectedFilterOptions[filter.title].length > 0 ? 'cursor-pointer' : ''"
                      (click)="toggleSelectedFilterOptionVisibility(filter.title)"
                  >
                    <div>
                      {{transformTitle(filter.title)}} ({{selectedFilterOptions[filter.title].length}} Selected)
                    </div>
                    <img
                      alt="select-box-search-box-icon-down"
                      src="assets/shared-icons/neptune-icon-black-chevron-down.svg"
                    />
                  </div>
                  <div *ngIf="showSelectedFiltersInModal[filter.title]" class="shadow-md">
                    <div 
                      *ngFor="let filterOption of selectedFilterOptions[filter.title]"
                      class="flex items-center justify-between px-4 py-2 border-l-[3px] border-solid border-transparent hover:border-l-blue hover:bg-neptune-color-primary-100"
                    >
                      <div class="text-sm">
                        {{filterOption}}
                      </div>
                      <img
                        *ngIf="true"
                        src="assets/shared-icons/neptune-icon-black-close.svg"
                        class="cursor-pointer h-[16px]"
                        (click)="removeFilter(filterOption)"
                        alt="cancel icon"
                      />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Pushes all preceding elements to the left -->
        <div class="advanced-filters-header-actions ml-auto flex items-center">
          <ng-content select="[advanced-filters-header-actions]"></ng-content>
        </div>

        <button
          type="button"
          id="clear-all"
          *ngIf="getVal().length > 1"
          class="neptune-button-white cursor-pointer w-[6em] h-[2em]"
          (click)="openClearAllConfirmModal()"
        >
          Clear All
        </button>
      </div>

      <!-- Clear All confirmation modal -->
      <div
        *ngIf="showClearAllConfirmModal"
        id="clear-all-confirm-overlay"
        class="fixed inset-0 z-[100] flex items-center justify-center bg-black/40"
        (click)="closeClearAllConfirmModal()"
      >
        <div
          id="clear-all-confirm-modal"
          class="w-[400px] bg-white rounded shadow-lg px-6 py-6"
          (click)="$event.stopPropagation()"
        >
          <div class="flex items-center justify-between pb-3 mb-4">
            <div class="text-neptune-default text-[18px]">Alert</div>
            <img
              src="assets/shared-icons/neptune-icon-black-close.svg"
              class="cursor-pointer h-[20px]"
              (click)="closeClearAllConfirmModal()"
              alt="cancel icon"
            />
          </div>
          <div class="text-center text-neptune-default">
            Are you sure you want to clear the selections made in advance filters?
          </div>
          <div class="flex justify-end gap-3 mt-6">
            <button
              type="button"
              id="clear-all-confirm"
              class="neptune-button-white cursor-pointer w-[5em] h-[3em] text-sm"
              (click)="confirmClearAll()"
            >
              Confirm
            </button>
            <button
              type="button"
              id="clear-all-cancel"
              class="neptune-button-blue cursor-pointer w-[5em] h-[3em] text-sm"
              (click)="closeClearAllConfirmModal()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      <ng-container
        *ngIf="
          filterGroups.length === 0;
          else productDetailsSection
        "
      >
        <div class="advanced-filters-body" *ngIf="toggleBody">
          <div
            id="advanced-filter-select-boxes"
            class="bg-light-gray flex flex-row flex-wrap gap-6 px-10 py-5 m-auto"
          >
            <div *ngFor="let filter of filterOptions">
              <select-box
                [id]="'adv-filters-select-' + filter.title"
                [title]="filter.title"
                [options]="filter.options"
                [(selectedOptions)]="selectedFilterOptions[filter.title]"
                [type]="filter.inputType"
                (updateSelectedOptions)="updateSelectedOptions($event)"
                [useRefreshedUi]="true"
              >
              </select-box>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #productDetailsSection>
        <div *ngFor="let group of filterGroups">
          <div class="advanced-filters-body" *ngIf="toggleBody">
            <div class="text-dark-gray text-sm font-medium pl-[50px] leading-normal whitespace-nowrap bg-light-gray pt-5">{{group.title}}</div>
            <div
              id="advanced-filter-select-boxes"
              class="bg-light-gray flex flex-row flex-wrap gap-6 px-10 py-5 m-auto"
            >
              <div *ngFor="let filter of group.filters">
                <select-box
                  [id]="'adv-filters-select-' + filter.title"
                  [title]="filter.title"
                  [options]="filter.options"
                  [(selectedOptions)]="selectedFilterOptions[filter.title]"
                  (updateSelectedOptions)="updateSelectedOptions($event)"
                >
                </select-box>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Reset and Apply Footer -->
      <div
        id="advanced-filters-footer"
        class="advanced-filters-footer shadow-[0_2px_0_0_theme(colors.border-gray)]"
        *ngIf="toggleBody || toggleFooter"
      >
        <div class="flex justify-end gap-[13px] py-3 px-5">
          <button
            id="adv-filter-reset"
            class="neptune-button-white cursor-pointer w-[8em] h-[2em]"
            (click)="resetFilters()"
          >
            Reset
          </button>
          <button
            id="adv-filter-apply"
            class="neptune-button-blue cursor-pointer w-[8em] h-[2em]"
            (click)="applyFilters()"
          >
            Apply
          </button>
        </div>
      </div>
    </div>

  </ng-container>
